export default {
      id: "ic_info_exclam-usage",
      viewBox: "0 0 44 42",
      url: "/" + "images/icons.3.109.2.svg#ic_info_exclam-usage",
      toString: function () {
        return this.url;
      }
    }